import config, { checkFeatureFlag } from 'config'
import { FIRST_AGENT_TAB } from 'app/constants/newChildAgent'
import { companyConfig } from 'globalConfigApp'

const NEWS_URL = config('NEWS_URL')
const INVOICE_URL = config('INVOICE_URL')
// Metricas del Asistente del Asesor (hermes). Sin host configurado no hay de
// donde leerlas, asi que la entrada no se pinta.
const ADVISOR_ASSISTANT_API_BASE_URL = config('ADVISOR_ASSISTANT_API_BASE_URL')

// Special menu items that require token for URL building
export const specialMenuItems = {
  start: [],
  end: [
    {
      name: 'Facturación',
      icon: 'ios-card',
      href: (token) => `${INVOICE_URL}?t=${token}`,
      external: true,
      ff: () => Boolean(INVOICE_URL)
    }
  ]
}

const menus = [
  {
    name: 'Panel de control',
    icon: 'ios-speedometer',
    href: '/dashboard'
  },
  {
    name: 'Captación de propiedades',
    icon: 'ios-stats',
    ff: checkFeatureFlag('show-on-hl-integration'),
    href: '/dashboard/leads'
  },
  {
    name: 'Mis propiedades',
    icon: 'ios-home',
    as: {
      pathname: '/dashboard/property-management',
      query: {
        status: 'APPROVED',
        page: 1
      }
    },
    href: {
      pathname: '/dashboard/property-management',
      query: {
        status: 'APPROVED',
        page: 1
      }
    },
  },
  {
    name: 'Documentación',
    icon: 'ios-book',
    href: '/dashboard/network-documentation',
  },
  {
    name: 'Contratos',
    ff: checkFeatureFlag('new-neximo-contracts'),
    icon: 'ios-folder-open',
    href: '/dashboard/contracts'
  },
  {
    name: 'Bolsa Inmobiliaria',
    icon: 'ios-pulse',
    children: [{
      name: 'Propiedades',
      as: '/dashboard/bin',
      href: '/dashboard/bin'
    },
    {
      name: 'Requerimientos',
      href: '/dashboard/bin/prospections',
      as: '/dashboard/bin/prospections',
      ff: checkFeatureFlag('show-on-hl-integration')
    },
    {
      name: 'Alertas',
      href: '/dashboard/bin/alerts',
      as: '/dashboard/bin/alerts'
    }
    ]
  },
  {
    name: 'Prospectos',
    icon: 'ios-contacts',
    ff: checkFeatureFlag('show-on-hl-integration'),
    children: [{
      name: 'Contactos',
      as: '/dashboard/crm/contacts',
      href: '/dashboard/crm/contacts'
    }]
  },
  {
    name: 'Estimado de valor',
    icon: 'ios-list-box',
    children: [{
      name: 'Mis reportes',
      as: '/dashboard/valuations',
      href: '/dashboard/valuations'
    }]
  },
  {
    name: `Universidad ${companyConfig.name}`,
    icon: 'ios-easel',
    children: [
      {
        name: 'Cursos',
        href: '/dashboard/elearning',
      },
      {
        ff: checkFeatureFlag('new-neximo-red'),
        name: 'Seguimiento',
        href: '/dashboard/tracing',
      },
      {
        // Estado de cumplimiento de la politica de capacitacion (R26-865).
        // Vive bajo Universidad porque es donde el asesor busca "como voy":
        // la pantalla mezcla Universidad, horas, facturacion e inventario.
        // Sin gate de contrato: a quien no le aplica la politica, la pantalla
        // se lo dice explicitamente en vez de desaparecer sin explicacion.
        name: 'Mi capacitación',
        href: '/dashboard/training-policy',
      },
    ]
  },

  {
    // Both legacy children ('PAP' and 'Mis comisiones') render the very same
    // MoneyPages screen in two segment states, so the tree collapses into a
    // single leaf. No `contractFeature` gate here on purpose: 'Mis comisiones'
    // never carried one, so gating the leaf would take the closings away from
    // advisors whose contract lacks PAP. MoneyPages degrades instead — it
    // drops the "Mi PAP" segment and lands them on the closings.
    isNew: true,
    name: 'PAP/Cierres',
    icon: 'md-repeat',
    ff: checkFeatureFlag('new-neximo-red'),
    href: '/dashboard/transactions/pap',
  },

  {
    // NEW MENU SECTION MY NETWORK
    name: `RED ${companyConfig.name}`,
    icon: 'md-contacts',
    ff: checkFeatureFlag('new-neximo-red'),
    children: [
      {
        name: 'Red',
        href: '/dashboard/network',
      },
      {
        name: 'Dar de alta',
        href: {
          pathname: '/dashboard/team/registerAgent',
          query: {
            section: FIRST_AGENT_TAB
          }
        },

        as: {
          pathname: `/dashboard/team/registerAgent/${FIRST_AGENT_TAB}`
        },
        ff: !checkFeatureFlag('hide-classic-broker-registration'),
      },
      {
        name: 'Invitar a Red',
        href: '/dashboard/team/landing-invitation',
        ff: checkFeatureFlag('self-service-share-landing'),
      },
      {
        name: 'Mi Equipo',
        href: '/dashboard/team/network',
      },
      {
        name: 'Comisiones de RED',
        href: '/dashboard/network/commissions',
      },
      {
        name: 'Retos e Incentivos',
        href: '/dashboard/network/stats',
        ff: checkFeatureFlag('network-stats'),
      },
      {
        name: 'Reporte de mi RED',
        href: '/dashboard/network/report',
        ff: checkFeatureFlag('network-stats-reports'),
      }
    ]
  },
  {
    name: `RED ${companyConfig.name}`,
    icon: 'md-globe',
    ff: !checkFeatureFlag('new-neximo-red'),
    children: [
      {
        name: 'Seguimiento',
        href: '/dashboard/team/tracing',
      },
      {
        isNew: true,
        name: 'Dar de alta',
        href: {
          pathname: '/dashboard/team/registerAgent',
          query: {
            section: FIRST_AGENT_TAB
          }
        },

        as: {
          pathname: `/dashboard/team/registerAgent/${FIRST_AGENT_TAB}`
        },
      },
      {
        name: 'Agente registrado',
        href: '/dashboard/team/registered-agent',
      },
      {
        name: 'Mi Equipo',
        href: '/dashboard/team/network',
      },
      {
        name: 'Mis comisiones',
        href: '/dashboard/team/commissions',
      },
    ]
  },
  {
    name: 'Estado de Cuenta',
    icon: 'ios-paper',
    href: '/dashboard/billing',
  },
  {
    ff: Boolean(NEWS_URL),
    name: 'Novedades de la plataforma',
    icon: 'md-paper',
    href: '/dashboard/news'
  },
  {
    name: 'Mi Asistente',
    icon: 'md-chatbubbles',
    ff: Boolean(ADVISOR_ASSISTANT_API_BASE_URL),
    href: '/dashboard/assistant-metrics'
  },
]

export default menus
